<template>
  <!-- Step 2: Select residence -->
  <div>
    <div class="nav-buttons">
      <circle-nav-button direction="prev" @click="goBack" />
    </div>
    <div class="text-center">
      <p>
        {{ $t("check-in-form.instruction-filter") }}
      </p>
    </div>
    <template v-if="localizedFilters.length > 0">
      <div
        v-for="(filter, index) in localizedFilters"
        :key="`f${index}`"
        class="form-group text-center"
      >
        <button
          class="btn-filter btn btn-outline-primary"
          :class="{ active: filterId === filter.id }"
          @click="() => chooseFilter(index)"
        >
          {{ filter.name }}
        </button>
      </div>
    </template>
    <template v-else>
      <div class="bg-light px-4 py-2 border rounded text-center">
        {{ $t(`check-in-form.message-filters-disabled`) }}
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.btn-filter {
  min-width: 200px;
}
</style>

<script>
import filtersApi from "@/api/localized-filters";
import questionsApi from "@/api/questions";

import CircleNavButton from "@/components/CircleNavButton";
import { mapState, mapActions } from "vuex";

export default {
  async beforeMount() {
    // Ensure previous step got processed.
    if (!this.facility.id) return this.$router.replace({ path: "/error-404" });
    if (!this.isFiltersEnabled()) {
      // 質問の取得完了を待たずに遷移すると、Step_3 が questions 未取得のままフォームを
      // 組み立ててしまい、予約情報からの事前入力とバリデーション定義が欠落する。
      // フィルタ選択時（chooseFilter）と同様に必ず取得完了を待ってから遷移する。
      try {
        await this.ensureQuestions();
      } catch (e) {
        console.error(e.message);
        this.$toast.error(this.$t("check-in-form.error-generic"), {
          position: "top"
        });
        return;
      }
      return this.goNext();
    }
    if (this.localizedFilters.length > 0) return;
    const filters = await filtersApi.showPublic(this.facility.id);
    this.updateLocalizedFilters(filters);
  },
  components: { CircleNavButton },
  computed: {
    ...mapState("checkin", [
      "facility",
      "filtersIndex",
      "localizedFilters",
      "questions"
    ]),
    filterId() {
      const filter = this.localizedFilters[this.filtersIndex];
      if (filter) return filter.id;
      return "";
    },
    isRequired() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.has('vericode');
    }
  },
  methods: {
    ...mapActions("checkin", [
      "updateSavedAnswers",
      "updateLocalizedFilters",
      "updateFiltersIndex",
      "updateQuestions",
      "updateQuestionMap",
      "updateSignatureImageData",
      "updateFaceImageData",
      "updateSkipFaceCapture"
    ]),
    async chooseFilter(index) {
      if (this.filtersIndex != index) {
        this.updateFiltersIndex(index);
        this.updateSavedAnswers({});
        // フィルタごとに顔認証・署名の有効/無効が変わるため、前フィルタで取得した
        // 画像データとスキップ指定を持ち越さない。残すと確認画面に前フィルタの署名が
        // 表示されたままになる。
        this.updateSignatureImageData("");
        this.updateFaceImageData("");
        this.updateSkipFaceCapture(false);
        await this.ensureQuestions();
      }
      this.$nextTick(this.goNext);
    },
    async ensureQuestions() {
      const options = { facility_id: this.facility.id, language: $i18n.locale };
      const filter = this.localizedFilters[this.filtersIndex];
      if (filter) options.facilities_localized_category_id = filter.id;
      const questions = await questionsApi.get(options);
      this.updateQuestions(questions.data);
      this.updateQuestionMap(this.buildQuestionMap(questions.data));
    },
    isFiltersEnabled() {
      const localizedFilter = this.facility.facility_setting.find(
        setting => setting.name == "localized-filter"
      );
      return localizedFilter.value.visibility;
    },
    buildQuestionMap(questionList) {
      const questionMap = {};
      questionList.forEach(question => {
        const { input_type, display_order, system_name } = question;
        questionMap[question.id] = { input_type, display_order, system_name };
      });
      return questionMap;
    },
    goBack() {
      // token無しURLから来た場合はstep-1には入れないようにする
      const confirmBooking = this.facility.confirmBooking;
      if(confirmBooking == true) return window.location.href = 'confirm?slug=' + this.facility.slug_name;
      
      if (this.isRequired) {
        return this.$router.replace({ name: "checkin-step-1", query: { vericode: 'on' } });
      } else {
        return this.$router.replace({ name: "checkin-step-1"});
      }
    },


    goNext() {
      if (this.isRequired) {
        this.$router.replace({ name: "checkin-step-3" , query: { vericode: 'on' }});
      } else {
        this.$router.replace({ name: "checkin-step-3" });
      }
    }
  }
};
</script>
